var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserPlaceholder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 36,
    fill: "#DBDDE0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.9999 40C42.6273 40 47.9999 34.6274 47.9999 28C47.9999 21.3726 42.6273 16 35.9999 16C29.3725 16 23.9999 21.3726 23.9999 28C23.9999 34.6274 29.3725 40 35.9999 40Z",
    fill: "#ADB1B8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9999 44C24.3722 44 14.6759 52.2689 12.4705 63.2472C18.7805 68.7011 27.005 72 35.9999 72C44.9948 72 53.2193 68.7011 59.5293 63.2472C57.3239 52.2689 47.6275 44 35.9999 44Z",
    fill: "#ADB1B8"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserPlaceholder);
export default __webpack_public_path__ + "static/media/user_placeholder.82462886f5e6d92e3806fa6d63c6fdd9.svg";
export { ForwardRef as ReactComponent };